import React from "react";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
    fontWeight: 600,
    color: "#333333",
    opacity: "0.75",
  },
  placeholder: {
    color: "#333333",
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600,
    opacity: "0.75",
  },
  openOpacity: {
    opacity: "1",
  },
});

export const Label = withStyles(styles)(
  ({ classes, open, orginal, selected, singleLabel, multipleLabel }) => {
    if (selected.length == 0) {
      return (
        <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>{singleLabel}</div>
      );
    }
    if (selected.length == orginal.length) {
      return (
        <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>
          {multipleLabel}(All)
        </div>
      );
    }
    return (
      <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>
        {selected.length < 2 ? singleLabel : multipleLabel} ({selected.length})
      </div>
    );
  }
);

export const SingleLabel = withStyles(styles)(({ classes, open, singleLabel, name }) => {
  if (!name) {
    return (
      <div className={`${classes.placeholder} ${open && classes.openOpacity}`}>{singleLabel}</div>
    );
  }
  return (
    <div className={`${classes.selectedPlaceholder} ${open && classes.openOpacity}`}>{name}</div>
  );
});
